import type { SecurityHighlightTarget } from "@/features/security/components/security-hero/security-hero-visual.constants";

export type SecurityActivityDefinition = {
  id: string;
  highlightTarget?: SecurityHighlightTarget;
};

export const SECURITY_ACTIVITY_DEFINITIONS: SecurityActivityDefinition[] = [
  { id: "act01", highlightTarget: "scriptProtection" },
  { id: "act02", highlightTarget: "shareLink" },
  { id: "act03", highlightTarget: "scriptProtection" },
  { id: "act04", highlightTarget: "scriptProtection" },
  { id: "act05" },
  { id: "act06" },
  { id: "act07", highlightTarget: "encryption" },
  { id: "act08", highlightTarget: "shareLink" },
  { id: "act09", highlightTarget: "encryption" },
  { id: "act10" },
  { id: "act11", highlightTarget: "shareLink" },
  { id: "act12" },
  { id: "act13" },
  { id: "act14", highlightTarget: "scriptProtection" },
  { id: "act15", highlightTarget: "scriptProtection" },
  { id: "act16", highlightTarget: "shareLink" },
  { id: "act17" },
  { id: "act18", highlightTarget: "scriptProtection" },
  { id: "act19" },
  { id: "act20", highlightTarget: "encryption" },
  { id: "act21", highlightTarget: "shareLink" },
  { id: "act22" },
  { id: "act23" },
  { id: "act24", highlightTarget: "scriptProtection" },
  { id: "act25" },
  { id: "act26", highlightTarget: "shareLink" },
  { id: "act27", highlightTarget: "scriptProtection" },
  { id: "act28" },
  { id: "act29", highlightTarget: "shareLink" },
  { id: "act30" },
];

export const SHARE_LINK_SETTING_KEYS = [
  "password",
  "inviteList",
  "permission",
  "expires",
  "watermark",
] as const;

export const AUDIT_VISUAL_EVENT_KEYS = [
  "evt01",
  "evt02",
  "evt03",
  "evt04",
] as const;

export const SESSION_VISUAL_DEVICE_KEYS = ["device01", "device02"] as const;

export const ACTIVITY_TIME_LABEL_KEYS = ["t0", "t1", "t2", "t3"] as const;

export const SCRIPT_PROTECTION_SHARE_MODE_IDS = [
  "password",
  "email",
  "expiry",
  "viewOnly",
  "watermark",
] as const;

export type ScriptProtectionShareModeId =
  (typeof SCRIPT_PROTECTION_SHARE_MODE_IDS)[number];

export const SCRIPT_PROTECTION_VISIBLE_LINES = [
  { key: "v01", type: "slugline" },
  { key: "v02", type: "action" },
  { key: "v03", type: "character" },
  { key: "v04", type: "parenthetical" },
  { key: "v05", type: "dialogue" },
] as const;

export const SCRIPT_PROTECTION_MASKED_LINES = [
  { key: "m01", type: "action" },
  { key: "m02", type: "character" },
  { key: "m03", type: "parenthetical" },
  { key: "m04", type: "dialogue" },
  { key: "m05", type: "action" },
  { key: "m06", type: "character" },
  { key: "m07", type: "parenthetical" },
  { key: "m08", type: "dialogue" },
  { key: "m09", type: "transition" },
] as const;
